module.exports = __webpack_public_path__ + "img/电脑.526f07b1.png";